import { Sport } from '@/types';
import { SportBadge } from '@/components/SportBadge';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

const SPORTS: Sport[] = ['badminton', 'football', 'volleyball', 'tennis', 'tabletennis', 'pickleball', 'basketball', 'swimming', 'golf', 'billiards', 'running', 'cycling'];

const SPORT_LABELS: Record<Sport | 'all', string> = {
  all: 'Tất cả',
  badminton: 'Cầu lông',
  football: 'Bóng đá',
  volleyball: 'Bóng chuyền',
  tennis: 'Tennis',
  tabletennis: 'Bóng bàn',
  pickleball: 'Pickleball',
  basketball: 'Bóng rổ',
  swimming: 'Bơi lội',
  golf: 'Golf',
  billiards: 'Bi-a',
  running: 'Chạy bộ',
  cycling: 'Đạp xe',
};

interface SportFilterProps {
  value: Sport | 'all';
  onChange: (value: Sport | 'all') => void;
  className?: string;
}

export function SportFilter({ value, onChange, className }: SportFilterProps) {
  return (
    <Select value={value} onValueChange={(v) => onChange(v as Sport | 'all')}>
      <SelectTrigger className={`[&>span]:line-clamp-none ${className}`} aria-label="Chọn môn thể thao">
        <SelectValue>
          {value === 'all' ? (
            <span className="flex items-center gap-2">
              <span className="shrink-0 text-base">🏆</span>
              <span>Tất cả môn</span>
            </span>
          ) : (
            <SportBadge sport={value} size="sm" />
          )}
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="bg-popover z-50">
        <SelectItem value="all" className="py-2">
          <span className="flex items-center gap-2">
            <span className="shrink-0 text-base">🏆</span>
            <span>Tất cả môn</span>
          </span>
        </SelectItem>
        {SPORTS.map((sport) => (
          <SelectItem key={sport} value={sport} className="py-2">
            <SportBadge sport={sport} size="sm" />
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
